import {deserializeSurvey, Survey} from "../../../../Survey";
import {
  DeserializedRecord,
  deserializeItem,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../../../../Helpers";

interface SectionSurvey extends DeserializedRecord{
  survey: Survey
}

interface SectionSurveyData extends JSONAPIRecord {
  relationships: {
    survey: JSONAPISingleRelationship
  }
}

type NewSectionSurvey = Pick<SectionSurvey, "survey">;

const deserializeSectionSurvey: Deserializer<SectionSurvey, SectionSurveyData> = (data, included) => {
  const survey = deserializeSingleRelationship<Survey>(data.relationships.survey, included, deserializeSurvey);

  return {
    survey,
    ...deserializeItem(data)
  };
};

export {
  SectionSurvey, NewSectionSurvey, deserializeSectionSurvey
};
